import { App } from 'vue';
import VueTippy from 'vue-tippy';

export default (app: App<Element>): App<Element> =>
  app.use(VueTippy, {
    defaultProps: {
      placement: 'right-start',
      allowHTML: true,
      offset: [-5, 20],
      popperOptions: {
        modifiers: [
          {
            name: 'arrow',
            options: {
              padding: 10, // 10px from the edges of the popper
            },
          },
        ],
      },
    },
  });

export { VueTippy };
